import React from 'react'

const Heading = ({ children }) => (
  <h4>{ children }</h4>
)

export default Heading



// WEBPACK FOOTER //
// ./src/containers/Home/Heading/Heading.js